import CatalogList from "../catalog/CatalogList";

/** Tela de produtos; as estruturas comuns do catálogo ficam centralizadas. */
const ProductList = () => <CatalogList type="PRODUCT" />;

export default ProductList;
